// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2fnTP","content":"styles_content__2TtnG","checkbox":"styles_checkbox__20eG_","checkboxLabel":"styles_checkboxLabel__VFAVu"};